import { Addition } from './mathAddition';
import { Common, SimpleGenEq, Numerals } from '../genHelper';

// Addition Equations
export class Math_Equation_Addition__To5__Base extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.single(2, 1, 5)), 'Math_Equation_Addition__To5__Base');
  }
}
export class Math_Equation_Addition__To10__Base extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.single(2, 1, 10)), 'Math_Equation_Addition__To10__Base');
  }
}
export class Math_Equation_Addition__To20__Base extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.single(2, 1, 20)), 'Math_Equation_Addition__To20__Base');
  }
}
export class Math_Equation_Addition__To20__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.single(3, 1, 20)), 'Math_Equation_Addition__To20__3Numbers');
  }
}
export class Math_Equation_Addition__To20__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.carrySingleDigit(20)), 'Math_Equation_Addition__To20__Carry');
  }
}
export class Math_Equation_Addition__To100__Base extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.single(2, 1, 100)), 'Math_Equation_Addition__To100__Base');
  }
}
export class Math_Equation_Addition__To100__3Numbers extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.single(3, 1, 100)), 'Math_Equation_Addition__To100__3Numbers');
  }
}
export class Math_Equation_Addition__To100__Carry extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.carrySingleDigit(100)), 'Math_Equation_Addition__To100__Carry');
  }
}
export class Math_Equation_Addition__To100__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.noCarry(2, 2)), 'Math_Equation_Addition__To100__NoCarry');
  }
}
export class Math_Equation_Addition__To1000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.noCarry(2, 3)), 'Math_Equation_Addition__To1000__NoCarry');
  }
}
export class Math_Equation_Addition__To1000000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.plusEq(Addition.noCarry(2, 6)), 'Math_Equation_Addition__To1000000__NoCarry');
  }
}

// Subtraction Equations
export class Math_Equation_Subtraction__To5__Base extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.single(2, 1, 5)), 'Math_Equation_Subtraction__To5__Base');
  }
}
export class Math_Equation_Subtraction__To10__Base extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.single(2, 1, 10)), 'Math_Equation_Subtraction__To10__Base');
  }
}
export class Math_Equation_Subtraction__To20__Base extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.single(2, 1, 20)), 'Math_Equation_Subtraction__To20__Base');
  }
}
export class Math_Equation_Subtraction__To20__Carry extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.carrySingleDigit(20)), 'Math_Equation_Subtraction__To20__Carry');
  }
}
export class Math_Equation_Subtraction__To100__Base extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.single(2, 1, 100)), 'Math_Equation_Subtraction__To100__Base');
  }
}
export class Math_Equation_Subtraction__To100__Carry extends SimpleGenEq {
  constructor() {
    super(
      Common.minusEq(Addition.carrySingleDigit(100)),
      'Math_Equation_Subtraction__To100__Carry'
    );
  }
}
export class Math_Equation_Subtraction__To100__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.noCarry(2, 2)), 'Math_Equation_Subtraction__To100__NoCarry');
  }
}
export class Math_Equation_Subtraction__To1000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.noCarry(2, 3)), 'Math_Equation_Subtraction__To1000__NoCarry');
  }
}
export class Math_Equation_Subtraction__To1000000__NoCarry extends SimpleGenEq {
  constructor() {
    super(Common.minusEq(Addition.noCarry(2, 6)), 'Math_Equation_Subtraction__To1000000__NoCarry');
  }
}

// Linear Equations
export class Math_Equation_Linear__1 extends SimpleGenEq {
  constructor() {
    super((data) => {
      while (true) {
        const x = data.random.next(-6, 6);
        const a = data.random.next(-10, 11);
        const b = data.random.next(-10, 11);
        if (x === 0 || a === 0 || b === 0) continue;
        const c = a * x + b;
        const q = `${Numerals.strAddOne(a, true)}x ${Numerals.strAdd(b)} = ${Numerals.strNum(c)}`;
        return { text: q, result: x };
      }
    }, 'Math_Equation_Linear__1');
  }
}

export class Math_Equation_Linear__2 extends SimpleGenEq {
  constructor() {
    super((data) => {
      while (true) {
        const x = data.random.next(-10, 11);
        const a = data.random.next(1, 6);
        const b = data.random.next(-5, 6);
        const c = data.random.next(1, 6);
        if (a === c) continue;
        const d = a * (x - b) - c * x;
        const q = `${Numerals.strOne(a)}(x ${Numerals.strAdd(-b)}) = ${Numerals.strOne(c)}x ${Numerals.strAdd(d)}`;
        return { text: q, result: x };
      }
    }, 'Math_Equation_Linear__2');
  }
}
